module.exports = __webpack_public_path__ + "img/fastcharger-rejected.e794c3c2.png";